import React, {useState} from 'react';
import Header from "../../../layouts/Header";

import debounce from 'lodash.debounce';
import { GiTwoCoins} from "react-icons/gi";
import {useNavigate} from "react-router-dom";
import {BsPin, BsShop} from "react-icons/bs";
import {showError} from "../../../utils/toastHelper";
import {getBrands, getLastSearches, getProductGroup, searchProducts} from "../api/HomeApi";
import Loading from "../../../layouts/Loading";

import {VscHistory} from "react-icons/vsc";
import {LuSearch} from "react-icons/lu";
import {IoMdArrowDropleft} from "react-icons/io";

import {PiAppleLogoDuotone, PiCubeDuotone} from "react-icons/pi";
import {TbCategory2} from "react-icons/tb";


const currencyFormat = Intl.NumberFormat('en-US');

function SearchProducts() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [products, setProducts] = React.useState([]);
    const [brands, setBrands] = React.useState([]);
    const [groups, setGroups] = React.useState([]);
    const [lastSearches, setLastSearches] = React.useState([]);
    const [term, setTerm] = React.useState('');
    const [title, setTitle] = React.useState('کالاها');
    const [sameCity, setSameCity] = useState(0);
    const [searchType, setSearchType] = useState('Product');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const config = window.APP_CONFIG;
    React.useEffect(() => {

        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)

        const fetchLastSearch = async () => {
            const search = window.localStorage.getItem("searchTerm")
            setTerm(search ? search : '');
            if (search && search.length > 1) {
                setLoading(true);
                const city = window.localStorage.getItem('_ci') || 0
                const params = {
                    search,
                    city,
                    platform: 'WebApp'
                }
                try {
                    const data = await searchProducts(params);
                    setProducts(data.data);

                } catch (err) {
                    showError(err);
                } finally {
                    setLoading(false);
                }
            }

        };
        const searchTypeV = window.localStorage.getItem("searchType")
        if (searchTypeV === 'Product') {
            fetchLastSearch();
        }


    }, []);

    React.useEffect(() => {
        const fetchLastSearches = async () => {

            const params = {}
            try {
                const data = await getLastSearches(params);
                if (data?.data) {
                    setLastSearches(data?.data[0]);
                }


            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }

        };
        fetchLastSearches();

    }, []);

    const performSearch = React.useCallback(async (searchTerm, sType = searchType) => {

        if (searchTerm.length <= 1) {
            setProducts([]);
            setGroups([]);
            setBrands([]);
            window.localStorage.removeItem('searchTerm')
            return;
        }

        const city = window.localStorage.getItem('_ci') || 0
        const params = {
            search: searchTerm,
            city,
            sType,
            platform: 'WebApp'
        };

        try {
            if (sType === 'Product') {
                const data = await searchProducts(params);
                setGroups([]);
                setBrands([]);
                setProducts(data.data);
            }
            if (sType === 'Brand') {
                const data = await getBrands(params);
                setProducts([]);
                setGroups([]);
                setBrands(data.data);
            }
            if (sType === 'Group') {
                const data = await getProductGroup(params);
                setProducts([]);
                setBrands([]);
                setGroups(data.data);
            }

        } catch (err) {
            showError(err);
        } finally {
            setLoading(false);

        }
    }, [searchType]);

    const debouncedSearch = React.useMemo(
        () => debounce(performSearch, 700),
        [performSearch]
    );

    React.useEffect(() => {
        return () => debouncedSearch.cancel();
    }, [debouncedSearch]);

    const onInputChange = (e) => {
        const value = e.target.value;
        setTerm(value);
        debouncedSearch(value);
    };

    if (loading) return <Loading/>;

    return (
        <React.Fragment>

            <Header title={'جستجوی ' + title} hasBack={true}/>

            <section className="container  mt-3 py-5 rtl  ">
                <div className="row search-city mx-2">
                    <div className="col-12  border-secondary border-opacity-25 position-relative">
                        <LuSearch className='text-secondary ' style={{fontSize: '1.8em'}}/>

                        <input
                            id='searchInput'
                            type="text" placeholder={'جستجو در همه ' + title}
                            className='text-secondary text-small-1 pe-3 w-75 border-0 bg-transparent no-visible-border'
                            value={term}
                            onChange={onInputChange}
                            autoFocus={true}
                        />


                        <span
                            className='float-start'
                            id='changeSearchType'
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        >
                        {searchType === 'Product' && <PiCubeDuotone className='search-type-icon'/>}
                            {searchType === 'Brand' && <PiAppleLogoDuotone className='search-type-icon'/>}
                            {searchType === 'Group' && <TbCategory2 className='search-type-icon'/>}
                </span>


                        {isDropdownOpen && (
                            <ul className="dropdown-menu show search-dropdown-menu bg-white">
                                <li className='border-bottom pb-2'>
                                    <button
                                        className={`dropdown-item ${searchType === 'Product' ? 'active' : ''}`}
                                        onClick={() => {
                                            setSearchType('Product');
                                            setTitle('کالاها');
                                            setIsDropdownOpen(false);
                                            setTimeout(() => {
                                                performSearch(term, 'Product')
                                            }, 200)

                                        }}
                                    >
                                        <PiCubeDuotone className="category-icon"/>
                                        کالاها
                                    </button>
                                </li>
                                <li className='border-bottom pb-2'>
                                    <button
                                        className={`dropdown-item ${searchType === 'Brand' ? 'active' : ''}`}
                                        onClick={() => {
                                            setSearchType('Brand');
                                            setTitle('برندها');
                                            setIsDropdownOpen(false);
                                            setTimeout(() => {
                                                performSearch(term, 'Brand')
                                            }, 500)
                                        }}
                                    >
                                        <PiAppleLogoDuotone className="category-icon"/>
                                        برندها
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className={`dropdown-item ${searchType === 'Group' ? 'active' : ''}`}
                                        onClick={() => {
                                            setSearchType('Group');
                                            setTitle('دسته بندی ها');
                                            setIsDropdownOpen(false);
                                            setTimeout(() => {
                                                performSearch(term,'Group' )
                                            }, 500)
                                        }}
                                    >
                                        <TbCategory2 className="category-icon"/>
                                        دسته بندی ها
                                    </button>
                                </li>
                            </ul>
                        )}
                    </div>

                </div>

                {
                    searchType === 'Product' && !products.length &&
                    <div className="row mx-1 mt-4 text-small-1">
                        <div className="col-12 home-separator-text ">
                            <VscHistory className='mx-2'/>
                            جستجوهای اخیر
                        </div>
                        <div className="col-12 ">
                            {
                                lastSearches.map((term, idx) => {
                                    return (
                                        <span
                                            key={idx}
                                            className='badge text-big-1 rounded bg-secondary-subtle border-secondary text-dark mx-1 px-4 mt-3 py-2'
                                            onClick={() => {
                                                performSearch(term)
                                                setTerm(term)
                                            }}
                                        >
                                        {term}
                                    </span>
                                    )
                                })
                            }
                        </div>
                    </div>
                }

                {
                    products.length > 0 &&
                    <div className="same-city-checkbox">
                        <label htmlFor="sameCityCheckbox" className='text-small-1'
                               style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            <input
                                type="checkbox"
                                id="sameCityCheckbox"
                                checked={sameCity === 1}
                                onChange={e => setSameCity(e.target.checked ? 1 : 0)}
                                style={{display: 'none'}}
                            />
                            <span className="custom-box" style={{marginLeft: '8px'}}></span>
                            فقط موارد مربوط به شهر
                            {" "}
                            <b className='mx-1'>
                                {window.localStorage.getItem('cityName') || 'همه شهرها'}
                            </b>
                            {" "}
                            نمایش داده
                            شود
                        </label>
                    </div>
                }

                {
                    !loading && products.map((product, index) => {
                            const price = product.price * (1 - (product.discount_percent / 100))
                            const city = window.localStorage.getItem('_ci') || 0
                            if (sameCity > 0 && product.city_id != city) {
                                return null;
                            }
                            return (
                                <div className="row my-2 product-search-card  mx-2 pt-2 px-0 " key={index}
                                     onClick={() => {
                                         window.localStorage.setItem("searchTerm", term);
                                         window.localStorage.setItem("searchType", searchType);
                                         window.localStorage.setItem("fromSearch", 1);
                                         navigate(`/product/${product.id}?vendor=${product.vendor_id}`);
                                     }}
                                >
                                    <div className="col-3 border-bottom pb-3 ">
                                        <img src={product.cover_image} alt={product.name} className='product-img'/>
                                    </div>
                                    <div className="col-9 fw-bolder text-muted border-bottom pb-3 ">

                                        {product.name}
                                        {product.price > 0 ?
                                            <div className='price-with-discount mt-3'>

                                                <GiTwoCoins className='ms-2 '/>
                                                {
                                                    product.discount_percent > 0 &&
                                                    <span
                                                        className='text-decoration-line-through fw-normal text-small-2 px-2 '>
                                                       {currencyFormat.format(product.price)}
                                                        &nbsp;
                                                        {config.currency}
                                            </span>
                                                }
                                                {currencyFormat.format(price)}
                                                &nbsp;
                                                {config.currency}
                                                &nbsp;

                                            </div> :
                                            <div className='text-small-2 text-muted'>
                                                <GiTwoCoins className='mx-2'/>
                                                قیمت استعلامی
                                            </div>
                                        }
                                    </div>
                                    <div className="col-10 py-2 text-small-3 fw-bold text-muted "
                                    >
                                        <BsShop className='mx-2 text-secondary'/>
                                        {product.vendor}
                                        <p className={product.same_city ? 'text-success-emphasis mt-2' : 'text-danger mt-2'}>
                                            <BsPin className='mx-2 text-secondary'/>
                                            {product.city}
                                        </p>
                                    </div>
                                    <div className="col-2 py-2 text-small-2 text-muted ">


                                        <img src={product.vendor_image} alt={product.vendor}
                                             className='product-img opacity-50 gray-img'/>

                                    </div>

                                </div>
                            );
                        }
                    )
                }

                <div className="my-3">&nbsp;</div>
                <div className="row mx-2  ">
                    {
                        brands.map(brand => {
                            return (
                                <div
                                    className="col-4 col-md-2 text-center brands "
                                    key={brand.id}
                                    onClick={() => {
                                        navigate(`/products?b=${brand?.id}&bn=${brand?.name}`)
                                    }}
                                >
                                    <div
                                        className="brand-image-container bg-white">
                                        <img src={brand.image} alt={brand.name}/>

                                        <div className='mt-3 text-small-1 text-muted'>
                                            {brand.name}
                                        </div>

                                    </div>

                                </div>
                            )
                        })

                    }

                </div>

                <div className="row mx-2 ">
                    {
                        groups.map(group => {
                            if (group.sub_categories_count < 1 && group.products.length < 1) {
                                return '';
                            }
                            return (
                                <div
                                    className="col-4 col-md-2 px-1 text-center product-group"
                                    key={group.id}
                                    onClick={
                                        () => {
                                            group.sub_categories_count > 0 ?
                                                window.location.assign(`/categories/${group.id}`) :
                                                window.location.assign(`/products/${group.id}`)
                                        }
                                    }
                                >
                                    <div className="group-image-container">
                                        <img src={group.image} alt={group.name}/>
                                        <div className="title mt-2">

                                            {group.name.substring(0, 14)}
                                            {
                                                group.name.length > 14 ?
                                                    <span className='text-small-4'>
                                                    ...
                                                </span>
                                                    : ''
                                            }
                                            {
                                                group.sub_categories > 0 &&
                                                <span>
                                                <IoMdArrowDropleft/>
                                            </span>
                                            }
                                        </div>
                                    </div>

                                </div>
                            )
                        })

                    }

                </div>

            </section>
        </React.Fragment>
    );
}

export default SearchProducts;